import {
  Box,
  Flex,
  Image,
  useColorMode,
  useColorStyle,
  Text,
  Stack,
  Scrollbar,
} from '@tonic-one/react';
import React from 'react';
import { SignIn } from './SignIn/index';
import { Summary } from './Summary/index';
import CSpinner from '@Components/CSpinner';
import { Reset } from './Reset';
import { Forgot } from './Forgot';
import logoMini from '../../assets/image/logo-mini.svg';
import addaLogoMini from '../../assets/image/white-label/cyber-eye.svg';
import powerByDark from '../../assets/image/white-label/powered-by-dark.svg';
import powerByLight from '../../assets/image/white-label/powered-by-light.svg';
import { IS_UAE } from '@Utils/const';
import { useTranslation } from 'react-i18next';
import Footer from '@Components/Footer';

export enum ResetPasswordStep {
  None = -1,
  Forgot = 0,
  Reset = 1,
}

const Header = () => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation();
  return IS_UAE ? (
    <Box
      height="60px"
      width="100%"
      background={
        colorMode === 'dark'
          ? colorStyle.background.secondary
          : colorStyle.background.primary
      }
      borderBottom={colorMode === 'dark' ? '' : '1px solid'}
      borderColor={colorMode === 'dark' ? '' : colorStyle.background.tertiary}
      display="flex"
      alignItems="center"
    >
      <Image src={addaLogoMini} height={28} ml="16px" />
      <Flex flexDirection="column" color={colorStyle.color.primary} ml={12}>
        <Text fontSize="20px" lineHeight="24px">
          Cyber Eye Cloud Service Security
        </Text>
        <Text fontSize="12px" lineHeight="16px">
          Stronger Security and Control for Cloud Applications
        </Text>
      </Flex>
    </Box>
  ) : (
    <Box
      height="60px"
      width="100%"
      background={
        colorMode === 'dark'
          ? colorStyle.background.secondary
          : colorStyle.background.primary
      }
      borderBottom={colorMode === 'dark' ? '' : '1px solid'}
      borderColor={colorMode === 'dark' ? '' : colorStyle.background.tertiary}
      display="flex"
      alignItems="center"
    >
      <Image src={logoMini} height={28} ml="16px" />
      <Box
        ml="12px"
        fontSize="20px"
        lineHeight="28px"
        color={colorStyle.color.primary}
      >
        <Box
          dangerouslySetInnerHTML={{
            __html: !IS_UAE
              ? t('common.productName')
              : 'Cyber Eye Cloud Service Security',
          }}
        />
      </Box>
    </Box>
  );
};
export const Login = () => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const [loading, setLoading] = React.useState<boolean>(true);

  return (
    <Scrollbar
      maxHeight="100vh"
      height="100vh"
      bg={colorStyle.background.primary}
    >
      <Flex flexDirection="column" height="100%">
        {loading && <CSpinner />}
        <div style={{ flex: 0 }}>
          <Header />
        </div>
        <Stack flex="1" my="auto" px="auto">
          <Flex
            justifyContent="center"
            alignItems="center"
            flex="1"
            position="relative"
          >
            <Flex alignItems="stretch">
              <Box flex="auto">
                <Box
                  width={672}
                  border={1}
                  borderColor={colorStyle.background.primary}
                >
                  <Summary setLoading={setLoading} />
                </Box>
              </Box>
              <Box flex="auto">
                <LoginForm setLoading={setLoading} />
              </Box>
            </Flex>
            <AddaPowerBy />
          </Flex>
        </Stack>
        <div style={{ flex: 0 }}>
          <Footer />
        </div>
      </Flex>
    </Scrollbar>
  );
};

const LoginForm = ({ setLoading }: { setLoading: (load: boolean) => void }) => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });

  const [resetPasswordStep, setResetPasswordStep] =
    React.useState<ResetPasswordStep>(() => {
      if (window.location.pathname.indexOf('/forgot') > -1) {
        return ResetPasswordStep.Reset;
      }
      return ResetPasswordStep.None;
    });

  const form = (() => {
    switch (resetPasswordStep) {
      case ResetPasswordStep.None:
        return (
          <SignIn
            setResetPasswordStep={setResetPasswordStep}
            setLoading={setLoading}
          />
        );

      case ResetPasswordStep.Reset:
        return (
          <Reset
            setResetPasswordStep={setResetPasswordStep}
            resetPasswordStep={resetPasswordStep}
          />
        );

      case ResetPasswordStep.Forgot:
        return <Forgot setResetPasswordStep={setResetPasswordStep} />;
    }
  })();

  return (
    <Box
      bg={colorStyle.background.secondary}
      borderRadius="8px"
      ml={80}
      border={1}
      borderColor={colorStyle.background.secondary}
    >
      {form}
    </Box>
  );
};

const AddaPowerBy = () => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });

  if (!IS_UAE) {
    return <></>;
  }

  return (
    <Flex
      position="absolute"
      bottom="0"
      right="0"
      bg={colorStyle.background.primary}
    >
      <Image
        src={colorMode === 'light' ? powerByDark : powerByLight}
        height={24}
        width={192}
        mr={24}
      />
    </Flex>
  );
};
